import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import TrendingFeed from '../components/TrendingFeed/TrendingFeed';

const ElectionLayout = ({ children }) => {
  return (
    <>
      <Header />
      <TrendingFeed />
      <main>{children}</main>
      <Footer />
    </>
  );
};

ElectionLayout.propTypes = {
  children: PropTypes.any,
};

export default ElectionLayout;
